import paperclip from './paperclip.svg';
import circleNotch from './circle-notch.svg';
import chevronRight from './chevron-right.svg';
export default {
    file: paperclip,
    loader: circleNotch,
    node: chevronRight
};
//# sourceMappingURL=Icons.js.map